import { render, staticRenderFns } from "./CCMLabsViewDialog.vue?vue&type=template&id=79956b36"
import script from "./CCMLabsViewDialog.vue?vue&type=script&lang=js"
export * from "./CCMLabsViewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports